// extracted by mini-css-extract-plugin
module.exports = {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__1CHLO","subTitleBold":"BoxSubTitle_subTitleBold__VKnOC"};